import React, { useEffect, useRef, useState } from 'react';
interface PromptDialogProps {
  title: string;
  label: string;
  confirmLabel: string;
  initialValue: string;
  onCancel: () => void;
  onConfirm: (value: string) => void;
}
export function PromptDialog({
  title,
  label,
  confirmLabel,
  initialValue,
  onCancel,
  onConfirm
}: PromptDialogProps) {
  const [value, setValue] = useState(initialValue);
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onCancel();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onCancel]);
  const trimmed = value.trim();
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-310" data-mp="2gck794y73vpg">
      <div className="absolute inset-0 bg-slate-900/40" onClick={onCancel} aria-hidden="true" data-id="element-311" data-mp="2bkabh8aeg1f9" />
      <form role="dialog" aria-modal="true" aria-labelledby="prompt-dialog-title" onSubmit={event => {
      event.preventDefault();
      if (trimmed.length === 0) return;
      onConfirm(trimmed);
    }} className="relative w-full max-w-sm rounded bg-white p-5 shadow-xl" data-id="element-312" data-mp="3ms3ivufx27lr">
        <h2 id="prompt-dialog-title" className="text-base font-semibold text-slate-900" data-id="element-313" data-mp="3hxqwbbj58g5s">
          {title}
        </h2>
        <label className="mt-3 block text-sm font-medium text-slate-700" data-id="element-314" data-mp="382yz48th3vbj">
          {label}
          <input ref={inputRef} value={value} onChange={event => setValue(event.target.value)} className="mt-1 w-full rounded border border-slate-300 px-2.5 py-1.5 text-sm text-slate-900 focus:border-[#0176d3] focus:outline-none focus:ring-1 focus:ring-[#0176d3]" data-id="element-315" data-mp="2u2wnv5fo8059" />
        </label>
        <div className="mt-5 flex justify-end gap-2" data-id="element-316" data-mp="x934m1cqd7b6">
          <button type="button" onClick={onCancel} className="rounded border border-slate-300 bg-white px-3 py-1.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0176d3] focus-visible:ring-offset-2" data-id="element-317" data-mp="uvg4pmnikfum">
            Cancel
          </button>
          <button type="submit" disabled={trimmed.length === 0} className="rounded bg-[#0176d3] px-3 py-1.5 text-sm font-semibold text-white transition hover:bg-[#014486] disabled:cursor-not-allowed disabled:opacity-60 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0176d3] focus-visible:ring-offset-2" data-id="element-318" data-mp="gxrhw99vyymx">
            {confirmLabel}
          </button>
        </div>
      </form>
    </div>;
}